import Header from '../../commons/components/header/Header';
import './signed-in.scss';

function SignedIn() {
    return (
        <>
            <div className="SignedInFull">
                <Header
                    title="¡Ya te encuentras postulando!"
                    isOnlyLogo={true}
                    isOnlyHeader={true}
                    name={' '}
                    progress={0}
                ></Header>
                <div className="SignedIn">
                    <div className="SignedInContent">
                        <p>
                            Si necesitas comunicarte con nosotros,<br></br>{' '}
                            escríbenos a{' '}
                            <a href="mailto:empresasquetransforman@ipae.pe">
                                empresasquetransforman@ipae.pe
                            </a>
                            .
                        </p>
                        <p className="SignedInGoodLuck">¡Gracias!</p>
                    </div>
                    <div className="SignedInCircle1"></div>
                    <div className="SignedInCircle2"></div>
                    <div className="SignedInCircle3"></div>
                </div>
            </div>
        </>
    );
}

export default SignedIn;
